import React from "react";
import { ModalSearchPaymentDetailProps } from "./interface";
import DefaultModal from "../ModalDefault";
import TablePaymentDetail from "../TablePaymentDetail";

const ModalSearchPaymentDetail: React.FC<ModalSearchPaymentDetailProps> = ({
  onSelect,
  ...props
}) => {
  return (
    <DefaultModal
      {...props}
      contentMaxW="1080px"
      title="Search Payment Detail"
      hideFooter
    >
      <TablePaymentDetail
        tableContainerProps={{
          maxH: "calc(100vh - 280px)",
          overflow: "auto",
        }}
        columnVisibility={{
          enable: false,
          isDefault: false,
        }}
        activeOnly
        hasRowSelection
        onSelect={onSelect}
      />
    </DefaultModal>
  );
};

export default ModalSearchPaymentDetail;
